import floor from "lodash/floor";
import dayjs, { Dayjs } from "dayjs";

const toAmbiguousAge = (date: Dayjs): number => {
  return floor(dayjs().diff(date, "year"), -1);
};

export default toAmbiguousAge;
